export const POST_DRAFT_INVALID_CATEGORY_ERROR_MESSAGE =
  'Invalid category supplied';

export const EMPTY_DRAFT = { description: '' };

export const DEFAULT_MAX_SELECTED_ITEMS_ALLOWED = 100;
export const DEFAULT_MAX_SELECTED_DROPS_ALLOWED = 1;

export const TableId = {
  Photo: 'photo',
  Description: 'description',
  Category: 'category',
  Size: 'size',
  Quantity: 'quantity',
  Brand: 'brand',
  Condition: 'condition',
  Colour: 'colour',
  Price: 'price',
  ShippingPrice: 'nationalShippingPrice',
  InternationalShippingPrice: 'internationalShippingPrice',
  SKU: 'sku',
} as const;

export const TABLE_HEADINGS = [
  { id: TableId.Photo, label: 'Photos', loadingPlaceholder: null },
  {
    id: TableId.Description,
    label: 'Description',
    loadingPlaceholder: 'double',
  },
  { id: TableId.Category, label: 'Category', loadingPlaceholder: 'double' },
  { id: TableId.Size, label: 'Size', loadingPlaceholder: 'double' },
  { id: TableId.Quantity, label: 'Quantity', loadingPlaceholder: 'double' },
  { id: TableId.Brand, label: 'Brand', loadingPlaceholder: 'double' },
  { id: TableId.Condition, label: 'Condition', loadingPlaceholder: 'single' },
  { id: TableId.Colour, label: 'Colour', loadingPlaceholder: 'single' },
  { id: TableId.Price, label: 'Price', loadingPlaceholder: 'single' },
  {
    id: TableId.ShippingPrice,
    label: 'ShippingPrice',
    loadingPlaceholder: 'single',
  },
  {
    id: TableId.InternationalShippingPrice,
    label: 'WorldwideShippingPrice',
    loadingPlaceholder: 'single',
  },
  {
    id: TableId.SKU,
    label: 'SKU',
    loadingPlaceholder: 'single',
  },
];

export const PLACEHOLDER_TEXT = '-';

export const CATEGORY_SEPARATOR = '>';

export const LOADING_TIMEOUT = 2000;

export const ANIMATION_TIMEOUT = 3000;
